<!--
 * @Description: 深度取证记录详情
 * @Date: 2019-12-25 15:05:43
 * @LastEditTime: 2021-06-19 18:30:14
 -->
<template>
  <div id="ForensicDetail">
    <el-dialog
      title="取证详情"
      :visible.sync="visible"
      width="550px"
    >
      <dl v-loading="detail.loading" class="detail-wrap">
        <!-- S 取证结果 -->
        <dt>取证结果</dt>
        <dd v-if="data.productName==='PC屏幕水印' || data.productName==='手机屏幕水印' || data.productName==='网页水印' || data.productName==='手机原生图片水印' || data.productName==='终端打印水印'">
          <span class="label">溯源标识：</span>
          <span class="value">{{ data.forensicResultVo ? (data.forensicResultVo.shfCode || '--') : '--' }}</span>
        </dd>
        <dd v-if="data.productName==='PC屏幕水印' || data.productName==='手机屏幕水印' || data.productName==='网页水印' || data.productName==='手机原生图片水印'">
          <span class="label">泄密时间：</span>
          <span class="value">{{ data.forensicResultVo ? (data.forensicResultVo.screenTime || '--') : '--' }}</span>
        </dd>
        <dd v-if="data.productName==='视频水印' || data.productName==='电子文档水印' || data.productName==='图片水印'">
          <span class="label">日志序号：</span>
          <span class="value">{{ data.forensicResultVo ? (data.forensicResultVo.serialNum || '--') : '--' }}</span>
        </dd>
        <dd v-if="data.productName==='终端打印水印'">
          <span class="label">日志序号：</span>
          <span class="value">{{ data.forensicResultVo ? (data.forensicResultVo.printSerialNum || '--') : '--' }}</span>
        </dd>
        <!-- E 取证结果 -->

        <!-- S 泄密样本信息 -->
        <dt>泄密样本信息</dt>
        <dd class="forensic-img">
          <div v-if="checkFileType(data.originalFileName) === 'pdf'" class="img">
            <img src="../../../assets/imgs/file.png" alt="">
          </div>
          <div v-else-if="checkFileType(data.originalFileName) === 'video'" class="img">
            <img src="../../../assets/imgs/u994.svg" alt="">
          </div>
          <div v-else class="img">
            <img v-lazy="data.thumbnailPath" alt="">
          </div>
          <ul>
            <li>
              <span class="label">样本名称</span>
              <span class="value">{{ data.imageName || '--' }}</span>
            </li>
            <li>
              <span class="label">本地原始名</span>
              <span class="value">{{ data.originalFileName || '--' }}</span>
            </li>
            <li>
              <span class="label">大小</span>
              <span class="value">{{ data.size || '--' }}</span>
            </li>
            <li>
              <span class="label">MD5：</span>
              <span class="value">{{ data.md5 || '--' }}</span>
            </li>
          </ul>
        </dd>
        <!-- E 泄密样本信息 -->

        <!-- S 取证信息 -->
        <dt>取证信息</dt>
        <dd>
          <span class="label">上传时间：</span>
          <span class="value">{{ data.createTime }}</span>
        </dd>
        <dd>
          <span class="label">取证用户：</span>
          <span class="value">{{ data.username }}</span>
        </dd>
        <dd>
          <span class="label">自助取证时间：</span>
          <span class="value">{{ data.selfForensicTime }}</span>
        </dd>
        <dd>
          <span class="label">申请时间：</span>
          <span class="value">{{ data.applicationTime }}</span>
        </dd>
        <dd>
          <span class="label">深度取证时间：</span>
          <span class="value">{{ data.depthForensicTime }}</span>
        </dd>
        <dd>
          <span class="label">备注：</span>
          <span class="value">{{ data.remark }}</span>
        </dd>
        <dd v-if="data.forensicResult === '失败'">
          <span class="label">取证失败原因：</span>
          <span class="value">{{ data.forensicResultVo ? (data.forensicResultVo.forensicFailReason || '--') : '--' }}</span>
        </dd>
        <!-- E 取证信息 -->
      </dl>
      <div class="footer">
        <el-button type="primary" @click="() => visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import { fillBlank } from '@/utils/tools'
import { checkFileType } from '../../selfForensic/Config.js'

export default {
  filters: {
    imageType(type) {
      switch (type) {
        case 1:
          return '虚拟打印的电子图'
        case 2:
          return ' 打印扫描图'
        case 3:
          return '手机或屏幕截屏图'
        case 4:
          return '纸张拍照图'
        case 5:
          return '屏幕拍照图'
        default:
          return '--'
      }
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    isDeep: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      data: {
        forensicResultVoList: [{
          shfCode: '',
          screenTime: ''
        }]
      },
      checkFileType
    };
  },
  computed: {
    ...mapState({
      detail: state => state.deepForensic.detail,
      forensicType: state => state.forensic.forensicType,
      productName: state => state.product.item.productName,
      screenTimeLabel: state => state.product.screenTimeLabel
    })
  },
  watch: {
    value(val) {
      this.visible = val
      this.$emit('input', val)
    },
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.getDepthForensicRecordDetail({ id: this.id }).then(res => {
          this.data = fillBlank(res)
        })
      }
    }
  },
  methods: {
    ...mapActions({
      getDepthForensicRecordDetail: 'deepForensic/getDepthForensicRecordDetail'
    })
  }
};
</script>
<style lang="scss">
@import '../../../assets/scss/variable.scss';

#ForensicDetail {
  .el-dialog {
		position: absolute;
		top: 0;
		left: 50%;
		margin-left: -275px;
		z-index: 2;
    .el-dialog__body {
      padding: 0;
    }
	}
  .detail-wrap {
    padding: 30px 20px;
    dt {
      position: relative;
      padding-left: 10px;
      margin-bottom: 20px;
      margin-top: 30px;
      color: #333;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 16px;
        background: $primaryColor;
      }
    }
    dt:first-child {
      margin-top: 0;
    }
    dd {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 8px;
      span {
        display: inline-block;
      }
      .label {
        width: 109px;
        padding-left: 9px;
      }
      .value {
        width: calc(100% - 109px);
        overflow: hidden;
        word-break: break-all;
      }
    }
    dd.forensic-img {
      display: flex;
      align-items: flex-end;
      .img {
        width: 110px;
        height: 88px;
        border: solid 1px #efefef;
        margin-right: 20px;
        margin-left: 9px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      ul {
        width: calc(100% - 139px);
        li {
          display: flex;
          margin-bottom: 8px;
          span {
            display: inline-block;
          }
          .label {
            width: 75px;
          }
          .value {
            width: calc(100% - 75px)
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    border-top: solid 1px #ededed;
    height: 60px;
    padding: 0 15px;
    box-sizing: border-box;
    .el-button {
      width: 72px;
      height: 30px;
      line-height: 30px;
      padding: 0;
    }
  }
}
</style>
